var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon36Telegram = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5 4.5C25.9558 4.5 32 10.5442 32 18C32 25.4558 25.9558 31.5 18.5 31.5C11.0442 31.5 5 25.4558 5 18C5 10.5442 11.0442 4.5 18.5 4.5ZM24.0195 12.6266C23.5118 12.6356 22.7321 12.9076 18.9834 14.4668L11.1106 17.8572C10.4718 18.1113 10.1371 18.3602 10.1064 18.6031C10.0479 19.0698 10.72 19.215 11.5654 19.4897C12.2546 19.7138 13.1817 19.9759 13.6638 19.9863C14.101 19.9958 14.5895 19.8158 15.1283 19.4458C18.8052 16.9638 20.7034 15.7089 20.8225 15.6819C20.9065 15.6631 21.0227 15.6394 21.1016 15.7094C21.1804 15.7795 21.1723 15.9119 21.1642 15.9478C21.0974 16.2326 17.6486 19.3703 17.4453 19.5809C16.6857 20.3698 15.8215 20.8527 17.1542 21.731L20.1666 23.7546C20.9259 24.2524 21.5217 24.843 22.3057 24.7709C22.6666 24.7376 23.0393 24.3981 23.2285 23.3866C23.6758 20.9956 24.5546 15.8159 24.7578 13.6813C24.7756 13.4942 24.7528 13.2546 24.7347 13.1495C24.7167 13.0445 24.679 12.8945 24.5425 12.7837C24.3807 12.6527 24.1311 12.6246 24.0195 12.6266Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon36Telegram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Icon36Telegram.57bdf6a39e92523671875faab7e1f1e6.svg";